import styled from "styled-components";

export const SectionContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  .slideWrapper {
    flex-flow: row nowrap;
    display: flex;
    flex: 1;
    width: 100%;
    transition: transform 0.5s ease;
    height: 100%;
    overflow: hidden;
    margin: auto;
    .slideContent {
      flex: 0 0 50%;
      transform: translateX(0);
      flex-basis: 100%;
      flex-shrink: 0;
      transition: 0.3s;
      width: 100%;
      overflow-x: hidden;
      box-sizing: border-box;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.7);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      .count {
        margin-top: 0;
      }
    }
  }
  .status span {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 5px;
    &.pending {
      color: #f1541d;
      background: #fef6f4;
    }
    &.completion {
      color: #429b8c;
      background: #e7f5f2;
    }
  }
  &.theme-2 {
    max-width: 1240px;
  }
  @media screen and (max-width: 767px) {
    .info {
      flex-wrap: wrap;
      .actions {
        width: 100%;
      }
    }
    .writing {
      margin: 0 0 30px auto;
    }
    &.theme-0 {
      .writing {
        width: 50%;
      }

      .detail {
        ul {
          li {
            flex-wrap: wrap;
            height: auto;
            padding: 0;
            margin-bottom: 10px;
            padding: 10px;
            .tit,
            .cont {
              width: 100%;
              padding: 0;
            }
            .tit {
              margin-bottom: 5px;
            }
            .cont {
            }
          }
        }
      }
    }
    &.theme-2 {
      .info .actions {
        text-align: right;
      }
    }
    &.theme-4 {
    }
  }
`;

export const NoticeListContainer = styled.ul`
  li {
    cursor: pointer;
  }
  &.theme-0,
  &.theme-2 {
    li {
      align-items: center;
      height: 70px;
      text-align: center;
      display: flex;
      &.header {
        font-size: larger;
        font-weight: 700;
      }
      &.not {
        cursor: default;
        justify-content: center;
      }
      .noticeNo,
      .noticeCl,
      .createMberId,
      .index,
      .id {
        width: 10%;
      }
      .noticeSj,
      .title {
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .createDt,
      .status {
        width: 20%;
      }
    }
  }
  &.theme-0 {
    border-top: 1px solid #000;
    li {
      border-bottom: 1px solid #000;
    }
  }

  &.theme-2 {
    border-top: 2px solid #222;
    li {
      border-bottom: 1px solid rgba(7, 7, 7, 0.5);
      color: #222;
    }
  }
  &.theme-4 {
    border-top: 1px solid #989898;
    li {
      display: flex;
      height: 100px;
      border-bottom: 1px solid #989898;
      position: relative;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 10px;
      padding: 0 200px;
      &.header,
      .createMberId {
        display: none;
      }
      .noticeNo,
      .createDt,
      .id {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      .noticeNo,
      .id {
        left: 50px;
        font-size: 40px;
        color: #c4c4c4;
        font-weight: 700;
      }
      .createDt {
        right: 50px;
        color: #7b7b7b;
      }
      .noticeCl,
      .noticeSj,
      .title,
      .status {
        text-align: left;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .noticeCl {
        order: 1;
        padding: 2px 0;
        color: #999;
      }
    }
  }

  @media screen and (max-width: 1050px) {
    &.theme-4 {
      li {
        padding: 0 200px 0 150px;
        .noticeNo,
        .id {
          font-size: 30px;
          left: 30px;
        }
        .createDt {
          right: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    &.theme-0,
    &.theme-2 {
      li {
        text-align: left;
        height: auto;
        &.header {
          display: none;
        }
        .noticeNo,
        .createMberId,
        .id {
          display: none;
        }
      }
    }
    &.theme-0 {
      li {
        flex-wrap: wrap;
        gap: 10px 30px;
        padding: 15px;
        .title,
        .noticeSj {
          width: 100%;
          margin-bottom: 10px;
        }
        .createDt {
          width: auto;
          max-width: 40%;
          order: 2;
          color: #777;
        }
        .noticeCl,
        .status {
          width: auto;
          max-width: 30%;
          order: 1;
          font-weight: 700;
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 80%;
            background: #999;
            position: absolute;
            top: 50%;
            right: -15px;
            transform: translate(50%, -50%);
          }
        }
      }
    }
    &.theme-2 {
      li {
        position: relative;
        display: block;
        padding: 15px 0;
        .title,
        .noticeSj {
          font-size: larger;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
        .title {
          width: calc(100% - 60px);
        }
        .noticeSj {
          width: 100%;
        }
        .noticeCl {
          display: none;
        }
        .createDt {
          display: block;
          width: 100%;
          margin-top: 8px;
          color: #999999;
        }
        .status {
          width: fit-content;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
    }
    &.theme-4 {
      border-top: none;
      li {
        padding: 10px;
        height: auto;
        gap: 5px;
        border: 1px solid #e7e7e7;
        background: #f5f5f5;
        margin-bottom: 10px;
        flex-wrap: wrap;
        align-items: baseline;
        flex-direction: row;
        justify-content: flex-start;
        .noticeNo,
        .id,
        .createDt {
          top: 0;
          transform: none;
          position: relative;
          text-align: left;
          width: 100%;
        }
        .noticeNo,
        .id {
          display: none;
        }
        .noticeSj,
        .title {
          order: 1;
          width: 100%;
        }
        .noticeCl,
        .status {
          order: 2;
          width: auto;
        }
        .noticeCl {
          color: #00aeef;
        }
        .createDt {
          width: auto;
          right: 0;
          order: 3;
        }
      }
    }
  }
`;

export const DetailContainer = styled.div``;
